import React from "react";
import {
  Form,
  Field,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import {
  passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import {  useNavigate } from "react-router-dom";
import { employeeLogin } from "./loginSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import FormCheckbox from "../../components/formFields/FormCheckbox";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import "./newlogin.scss";
import AnimatedCrownRingLogo from "./AnimatedCrownRingLogo";

const NewLogIn: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const loading = useAppSelector((state) => state.login.loading);

  const handleSubmit = async (values: any) => {
    const data = {
      user_name: values.UserName,
      password: values.Password,
    };
    const response = await dispatch(employeeLogin(data));
    if (response?.meta?.requestStatus === "fulfilled") {
      navigate("/");
    }
  };

  return (
    <div className="login-container">
      <div className="luxury-overlay">
        <div className="diamond-pattern"></div>
        <div className="gold-line l1"></div>
        <div className="gold-line l2"></div>
        <div className="gold-line l3"></div>
        <div className="sparkle s1"></div>
        <div className="sparkle s2"></div>
        <div className="sparkle s3"></div>
        <div className="sparkle s4"></div>
      </div>

      <div className="login-content">
        <div className="company-branding">
          <div className="light-reflect"></div>
          <AnimatedCrownRingLogo size={200} />
          {/* <div className="logo">
            <div className="diamond-shape">
            </div>
          </div> */}
          <h1>HK JEWELLERS</h1>
          <p>Premium Inventory Management System</p>
        </div>

        <div className="login-form-container">
          <div className="form-header">
            <h2>Sign In to Portal</h2>
            <p>Enter your credentials to access your account</p>
          </div>

          <Form
            onSubmit={handleSubmit}
            initialValues={{
              UserName: "",
              Password: "",
              RememberMe: false,
            }}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement>
                <div className="form-group">
                  <Field
                    label="Username"
                    name={"UserName"}
                    type={"text"}
                    component={FormTextField}
                    validator={requiredValidator}
                    placeholder="Enter your username"
                  />
                </div>

                <div className="form-group">
                  <Field
                    label="Password"
                    name={"Password"}
                    type={"password"}
                    component={FormPasswordField}
                    validator={passwordValidator}
                    placeholder="Enter your password"
                  />
                </div>

                {/* <div className="form-options">
                  <Field
                    wrapperClassName={"remember-me"}
                    id={"RememberMe"}
                    name={"RememberMe"}
                    label={"Remember me"}
                    component={FormCheckbox}
                  />
                  <Link to="/" className="forgot-link">
                    Forgot password?
                  </Link>
                </div> */}

                <ButtonWithLoading
                  label="Sign In"
                  themeColor="primary"
                  type="submit"
                  width="100%"
                  style={{ padding: "10px" }}
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />

                <div className="register-section">
                  <p>Your information is securely encrypted</p>
                </div>
              </FormElement>
            )}
          />
        </div>

        <div className="copyright">
          <p>Crafting Excellence Since 1985</p>
          <p>&copy; 2023 HK Jewellers. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default NewLogIn;
